import { AppBar, Toolbar, MenuItem, ListItemIcon, Stack, ButtonBase, IconButton, Drawer, Avatar, Badge } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect } from 'react';
import logo from "../../assets/svg/logo.svg";
import { AccountCircle, Logout } from '@mui/icons-material';
import DDMenu from '../DDMenu';
import { useNavigate } from 'react-router-dom';
import route from '../../utils/Routes';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { formatName, isNotEmpty, makeTxtOverFLow } from '../../utils/format';
import { useState } from 'react';
import NotificationPage from '../../pages/CompanyUser/Notification/NotificationPage';
import { useQuery, useQueryClient } from 'react-query';
import QueryKey from '../../utils/QueryKey';
import { useAuthContext } from '../../context/AuthContext';
import { getNavData } from '../../services/amtc-service';
import constants from '../../utils/Constants';
import { getFileUrl } from '../../services/s3-service';
import { customAlert } from '../notify';
import LogoutPopup from '../LogoutPopup';
import BlurImg from '../BlurImg';
import { getSingleComServ } from '../../services/com-service';

function NavBar() {
    const queryClient = useQueryClient();
    const [anchorEl, setAnchorEl] = useState(null);
    const { setLoadingScreen, ctxtUser, setAsyncLoading, ctxtlogout, navCom } = useAuthContext();
    const open = Boolean(anchorEl);
    const navigate = useNavigate();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const { data: navData, isLoading } = useQuery([QueryKey.comUserProfile, ctxtUser.userId],
        () => getNavData(ctxtUser?.userId, ctxtUser?.isComUser),
        {
            enabled: isNotEmpty(ctxtUser?.userId),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
            refetchInterval: 30000,
        });
    const fontColor = "rgba(0, 0, 0, 0.8)";
    const [lgOpen, setLgOpen] = useState(false);
    const userMenuList = [
        {
            title: "Account",
            icon: <AccountCircle fontSize="small" />,
            fn: handleProfileClick
        },

        {
            title: "Logout",
            icon: <Logout fontSize="small" />,
            fn: handleLgOpen
        }
    ];

    const { isLoading: isUserImgLoading, data: userImgUrl } = useQuery([QueryKey.img, navData?.profileImg],
        () => getFileUrl({ fileKey: navData?.profileImg }), {
        enabled: isNotEmpty(navData?.profileImg),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    const { isLoading: isComDataLoading, data: comData } = useQuery([QueryKey.singleCom, navCom?.comId],
        () => getSingleComServ(navCom?.comId), {
        enabled: isNotEmpty(navCom?.comId),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    const { isLoading: isComImgLoading, data: comImgUrl } = useQuery([QueryKey.img, comData?.logo],
        () => getFileUrl({ fileKey: comData?.logo }), {
        enabled: isNotEmpty(comData?.logo),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });


    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        setLoadingScreen(isUserImgLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUserImgLoading]);

    useEffect(() => {
        setLoadingScreen(isComDataLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isComDataLoading]);

    useEffect(() => {
        setLoadingScreen(isComImgLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isComImgLoading]);


    function handleLgOpen() {
        setLgOpen(true)
    }

    function handleLgClose() {
        setLgOpen(false)
    }


    const toggleDrawer = (open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setIsDrawerOpen(open);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleCartClick() {
        navigate(route.addProductRequest);

    };

    async function handleLogout() {
        try {
            setAsyncLoading(true);
            await ctxtlogout();
            setAsyncLoading(false);
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
    }

    async function handleProfileClick() {
        if (ctxtUser?.isComUser) {
            navigate(route.reqProfile)
        } else {
            navigate(route.aProfile)
        }
    }

    function handleNotifyClose() {
        queryClient.invalidateQueries([QueryKey.comUserProfile, ctxtUser.userId]);
        setIsDrawerOpen(false);
    }

    return (
        <Box flexGrow={1}>
            <AppBar position='static' color='primary' elevation={0} sx={{ borderBottom: 1, borderColor: "#E3E3E3" }}>
                <Toolbar variant="dense">
                    <Box flexGrow={1}  >
                        <ButtonBase component={"div"} onClick={() => navigate("/", { replace: true })}>
                            <Box component="img" alt="Comoany Logo" src={logo} sx={{ height: 45 }} />
                        </ButtonBase>
                    </Box>
                    <Stack direction={"row"} gap={2} >
                        {isNotEmpty(navCom?.comId) && <Stack direction={"row"} alignItems={"center"} ml={2}>
                            <Avatar sx={{ height: 30, width: 30 }} >
                                <BlurImg imgUrl={comImgUrl} alt={"company"} />
                            </Avatar>
                            <Box sx={{ fontSize: 15, px: 1, fontWeight: "500", color: fontColor }}>  {makeTxtOverFLow(comData?.comName, 24)}</Box>
                        </Stack>}

                        <IconButton onClick={toggleDrawer(true)}>
                            <Badge
                                color="error"
                                variant="dot"
                                invisible={!navData?.hasNewNotify}
                            >
                                <NotificationsNoneOutlinedIcon sx={{ color: fontColor }} />
                            </Badge>
                        </IconButton>
                        {(ctxtUser?.userType === constants.requestor || ctxtUser?.userType === constants.approver) &&
                            <IconButton onClick={handleCartClick}>
                                <ShoppingCartOutlinedIcon sx={{ color: fontColor }} />
                            </IconButton>}

                        <ButtonBase component="div" onClick={(handleClick)} sx={{ color: fontColor }}>
                            <Stack direction={"row"} alignItems={"center"} ml={2}>
                                <Avatar sx={{ height: 30, width: 30 }} >
                                    <BlurImg imgUrl={userImgUrl} alt={"profile"} />
                                </Avatar>
                                <Box sx={{ fontSize: 15, px: 1, fontWeight: "500" }}>  {makeTxtOverFLow(formatName(navData?.fName, navData?.lName), 24)}</Box>
                            </Stack>
                        </ButtonBase>

                        <DDMenu open={open} handleClose={handleClose} anchorEl={anchorEl} >
                            {userMenuList.map(
                                (i) => <MenuItem onClick={() => { i.fn(); }} key={i.title}>
                                    <ListItemIcon > {i.icon}</ListItemIcon>
                                    {i.title}

                                </MenuItem>)}
                        </DDMenu>
                    </Stack>
                </Toolbar>
            </AppBar>

            <Drawer
                anchor="right"
                open={isDrawerOpen}
                onClose={handleNotifyClose}>
                <NotificationPage handleClose={handleNotifyClose} />
            </Drawer>
            <LogoutPopup open={lgOpen} handleClose={handleLgClose} handleLogout={handleLogout} />
        </Box>
    )
}
export default NavBar;